import { gql } from "@apollo/client";

export const USER_LOGIN = gql`
  mutation UserLogin($email: String!, $password: String!) {
    userLogin(email: $email, password: $password) {
      isSuccess
      message {
        messageEn
        messageKh
      }
      data {
        user {
          _id
          userProfile
          khmerName
          latinName
          email
          gender
          role
          phoneNumber
          isEnabledAccess
        }
        token
      }
    }
  }
`;

// export const GET_USER_LOGIN = gql`
//   query Data {
//     getUserLogin {
//       data {
//         _id
//         email
//         gender
//         isEnabledAccess
//         khmerName
//         latinName
//         phoneNumber
//         role
//         userProfile
//       }
//       isSuccess
//       message {
//         messageEn
//         messageKh
//       }
//     }
//   }
// `;

export const FORGOT_PASSWORD = gql`
mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email) {
    is_success
    message {
      message_en
      message_kh
    }
  }
}
`;

export const VERIFY_OTP = gql`
mutation VerifyOTP($email: String!, $otp: String!) {
  verifyOTP(email: $email, otp: $otp) {
    data {
      token
      user_id
    }
    is_success
    message {
      message_en
      message_kh
    }
  }
}
`;

export const RESET_PASSWORD = gql`
  mutation ResetPasswordWhenForgot($email: String!, $password: String!) {
    resetPasswordWhenForgot(email: $email, password: $password) {
      isSuccess
      message {
        messageEn
        messageKh
      }
    }
  }
`;

// ============================================ New User Schema ============================================
export const LOGIN = gql`
  mutation LogIn($input: LogInInput) {
    logIn(input: $input) {
      message {
        message_en
        message_kh
      }
      is_success
      data {
        token
        user {
          _id
          last_name
          first_name
          latin_name
          role
          gender
          phone_number
          email
          is_enabled
        }
      }
    }
  }
`;

export const CREATE_USERS = gql`
  mutation CreateUser($input: CreateUserInput) {
    createUser(input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_USER_WITH_PAGINATION = gql`
  query GetUserPagination(
    $keyword: String
    $page: Int
    $limit: Int
    $pagination: Boolean
    $role: UserRole
  ) {
    getUserPagination(
      keyword: $keyword
      page: $page
      limit: $limit
      pagination: $pagination
      role: $role
    ) {
      data {
        _id
        last_name
        first_name
        latin_name
        role
        gender
        phone_number
        email
        is_enabled
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_USER_STATUS = gql`
  mutation UpdateUserStatus($id: ID!, $input: UpdateUserStatusInput!) {
    updateUserStatus(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($id: ID!, $input: UpdateUserInput) {
    updateUser(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const UPDATE_USER_PWD = gql`
  mutation UpdateUserPassword($id: ID!, $input: UpdateUserPwd!) {
    updateUserPassword(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_USER_LOGIN = gql`
query GetUserLogin {
  getUserLogin {
    data {
      _id
      last_name
      first_name
      latin_name
      role
      gender
      phone_number
      email
      is_enabled
    }
    is_success
    message {
      message_en
      message_kh
    }
  }
}
`